import { render, staticRenderFns } from "./Sidentify.vue?vue&type=template&id=60e8de0a&scoped=true&"
import script from "./Sidentify.vue?vue&type=script&lang=js&"
export * from "./Sidentify.vue?vue&type=script&lang=js&"
import style0 from "./Sidentify.vue?vue&type=style&index=0&id=60e8de0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e8de0a",
  null
  
)

export default component.exports